import React, { useState } from 'react'
import { Image } from '@sainsburys-tech/bolt'
import { isEmail } from '@sainsburys-tech/bolt-validators'
import QandAFormView from './QandAFormView'
import QandAPreview from './QandAPreview'
import * as Styled from './QandAForm.styles'

const QandAForm = ({ ...props }) => {
  const formFields = {
    question: '',
    additionalDetails: '',
    nickname: '',
    location: '',
    age: '',
    gender: '',
    email: '',
    yourAnswer: '',
    emailQuestionPosted: false,
    emailQuestionAnswered: false,
    acceptTsandCs: false,
    emailError: '',
    nicknameError: '',
    questionError: '',
    acceptTsandCsError: '',
    yourAnswerError: '',
    type: 'question'
  }
  const [viewState, setViewState] = useState('form')
  const [formData, setFormData] = useState(formFields)

  const onPreview = () => {
    setViewState('preview')
  }

  const onEdit = () => {
    setViewState('form')
  }

  const sanitiseString = str => str.replace(/[^a-z0-9!@?\s.,_-]/gim, '')

  const setCheckInput = formField => () => {
    const value = !formData[formField]
    if (formField === 'acceptTsandCs') {
      setFormData({ ...formData, [formField]: value, acceptTsandCsError: '' })
    } else {
      setFormData({ ...formData, [formField]: value })
    }
  }

  const setInput = formField => event => {
    const value = sanitiseString(event.target.value)
    setFormData({ ...formData, [formField]: value })
  }

  const validateEmail = () => {
    if (!isEmail(formData.email.trim())) {
      setFormData({ ...formData, emailError: 'Please enter your email address' })
    } else {
      setFormData({ ...formData, emailError: '' })
    }
  }

  const validateInput = formField => () => {
    const value = formData[formField].trim()
    if (!value || value.length < 2) {
      setFormData({ ...formData, [`${formField}Error`]: `Please enter your ${formField}` })
    } else {
      setFormData({ ...formData, [`${formField}Error`]: `` })
    }
  }

  const getValidObject = action => {
    const basic = {
      questionError:
        (props.type === 'question' && !formData.question) || formData.questionError ? 'Please enter your question' : '',
      nicknameError: !formData.nickname || formData.nicknameError ? 'Please enter your nickname' : '',
      emailError: !formData.email || formData.emailError ? 'Please enter your email address' : '',
      yourAnswerError:
        (props.type === 'answer' && !formData.yourAnswer) || formData.yourAnswerError ? 'Please enter your answer' : ''
    }
    const advanced = {
      acceptTsandCsError: !formData.acceptTsandCs ? `Please accept T's and C's to submit your question` : ''
    }
    const retVal = action === 'preview' ? { ...basic } : { ...basic, ...advanced }
    return retVal
  }

  const handleSubmit = (event, action = 'submit') => {
    event.preventDefault()
    const validObj = getValidObject(action)
    if (Object.values(validObj).some(element => element.includes('Please'))) {
      setFormData({ ...formData, ...validObj })
    } else {
      /* eslint-disable */
      action === 'preview' && onPreview()
      action === 'submit' && props.onSubmit(formData)
    }
  }
  const question = props.question

  return (
    <div>
      {props.type === 'question' ? (
        <Styled.Heading>{`${viewState === 'form' ? 'Ask' : 'Preview'} your question`}</Styled.Heading>
      ) : (
        <Styled.Heading>{`${viewState === 'form' ? 'Answer a question' : 'Preview your answer'}`}</Styled.Heading>
      )}

      <Styled.Contents>
        <Styled.FormWrapper>
          {viewState === 'form' && (
            <QandAFormView
              {...{
                formData,
                onPreview,
                setInput,
                setCheckInput,
                validateInput,
                validateEmail,
                handleSubmit,
                question,
                ...props
              }}
            />
          )}
          {viewState === 'preview' && (
            <QandAPreview
              {...{
                formData,
                onEdit,
                setCheckInput,
                handleSubmit,
                ...props
              }}
            />
          )}
        </Styled.FormWrapper>
        <Styled.ProductDetail>
          <Styled.ProductHeading>{props.productName}</Styled.ProductHeading>
          <Styled.ImageWrapper>
            <Image src={props?.images[0]} alt={props.productName} width='440' height='440' quality='70' lazy />
          </Styled.ImageWrapper>
        </Styled.ProductDetail>
      </Styled.Contents>
    </div>
  )
}

export default QandAForm
